var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home antialiased font-sans  flex flex-col h-full" },
    [
      _vm.hasLoaded
        ? _c("Topbar", {
            on: {
              showOnboarding: function($event) {
                _vm.showOnboardingModal = true
              }
            }
          })
        : _vm._e(),
      _vm.hasLoaded
        ? _c("router-view")
        : _c(
            "div",
            { staticClass: "text-center flex flex-col h-full justify-center" },
            [
              _c(
                "h1",
                {
                  staticClass:
                    "text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight"
                },
                [_vm._v(" Welcome to Carthike ")]
              )
            ]
          ),
      _vm.showOnboardingModal
        ? _c("OnboardingVideoModal", { on: { close: _vm.onModalClose } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }